/* unplugin-vue-components disabled */import script from "./list.vue?vue&type=script&setup=true&lang=ts"
export * from "./list.vue?vue&type=script&setup=true&lang=ts"

import "./list.vue?vue&type=style&index=0&id=120bbb8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120bbb8c"]])

export default __exports__